/** Build the culling viewport from a 3D Map3DElement (center + range). */

import { CLIENT_CONFIG } from '@/config';
import { boxForCamera3D } from '../h3/h3-utils';
import type { ViewportState } from '@/stores/map-viewport-store';
import { expandBox, boxCenter } from './viewport-box';

/** Read the 3D camera's center + range into a normalized {@link ViewportState}. */
export function viewportFrom3D(map3d: google.maps.maps3d.Map3DElement): ViewportState | null {
  const center = map3d.center as { lat: number; lng: number } | null;
  const range = map3d.range;
  if (!center || typeof range !== 'number' || range <= 0) return null;

  const box = expandBox(boxForCamera3D({ lat: center.lat, lng: center.lng }, range));
  return { box, center: boxCenter(box), active: range <= CLIENT_CONFIG.viewportMaxRange3D };
}
